module.exports = __webpack_public_path__ + "img/identify_edit2.fec4c513.png";